import React from 'react'
import Button from '../../Button'
import { FormContext } from '../context'
import type { FormValues } from '..'

interface ISubmitButtonProps {
  fullWidth?: boolean
  children: React.ReactNode
  onClick?: (form: FormValues) => void
}

const SubmitButton = ({ children, fullWidth, onClick }: ISubmitButtonProps) => {
  const { form } = React.useContext(FormContext)

  return (
    <Button
      type="submit"
      variant="filled-rounded"
      size="large"
      fullWidth={fullWidth}
      onClick={() => onClick?.(form)}
    >
      {children}
    </Button>
  )
}

SubmitButton.displayName = 'Form.SubmitButton'
export default SubmitButton
